import React, {useState} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Modal, Row, Col} from "reactstrap"
import ModalEditConcierge from "./ModalEditConcierge"

// Icon
import CloseIcon from '../../images/close-button-black.png';
import { IconContext } from 'react-icons';
import { GrAdd, GrClose } from 'react-icons/gr';
import { FaCheckCircle } from 'react-icons/fa';

// Image
import ConciergeNoList from "../../images/no-concierge.png"

function ModalConciergeList({isOpen, onToggle, conciergeData}) {

  const [showEdit, setShowEdit] = useState(false)
  const [item, setItem] = useState({})

  function showEditModal(item){
    setShowEdit(!showEdit)
    setItem(item)
  }

  function checkItemStatus(item){
    switch(item.status){
      case "NEW":
        return "In Queue";
      case "ASSIGNED":
        return "Assigned to concierge";
      case "AWAITING_DP":
        return "Please make down payment";
      case "SALE_CREATED":
        return "Shipping";
      case "NOT_FOUND":
        return "Sorry! Couldn't find your product";
      case "IN_PROGRESS":
        return "Your product OTW to our warehouse";
      case "AWAITING_FP":
        return "Please make full payment";
      default:
        return "Sale cancelled"
    }
  }

  if(showEdit && item){
    return <ModalEditConcierge item={item} isOpen={showEdit} toggle={showEditModal} title={"CONCIERGE DETAIL"} />
  } else {
    return (
      <Modal 
        className={"modal-concierge-list"} 
        isOpen={isOpen} 
        toggle={onToggle}
      >
        {
          conciergeData.length > 0 ? 
          <>
            <div style={{padding: window.screen.availWidth < 480 && "20px 20px 0px 20px"}} className="concierge-list-header">
              <h4>Concierge List</h4>
            </div>
            <div className="concierge-list-content">
            {
              conciergeData.map((item, i) => (
                <Row key={item.id}>
                  <Col sm={2} md={4} lg={4}>
                    <p>{item.name}</p>
                    <p>+{item.phone_number}</p>
                    <p>{item.condition && item.condition2 ? "Brand New / Used" : item.condition && !item.condition2 ? "Brand New" : "Used"}</p>
                    <p>{item.shipping.alias}</p>
                    <p>{item.shipping.country === "IDN" ? "Indonesia" : item.shipping.country === "MYS" ? "Malaysia" : "Singapore"}</p>
                    <p className="concierge-status">{checkItemStatus(item)}</p>
                  </Col>
                  <Col sm={10} md={8} lg={8}>
                    <div className="concierge-list-right">
                      {
                        item.status === "NEW" || item.status === "ASSIGNED" ? <h4 style={{marginTop: window.screen.availWidth < 480 && "0px", fontSize: window.screen.availWidth < 480 && "12px"}} onClick={() => showEditModal(item)} className="concierge-edit">Edit</h4> : null
                      }
                    </div>
                  </Col>
                </Row>
              ))
            }
            </div>
          </>
            : 
            <>
            <div className="concierge-list-empty">
              <Row style={{boxShadow: "none", overflowY: "none", margin: "0px"}}>
                <Col sm={12} md={12} lg={12}>
                <div className="concierge-no-req">
                  <KickImage src={ConciergeNoList} alt="no list concierge"/>
                  <h3>No Concierge Request</h3>
                  <h6>You don't have any request at this moment</h6>
                </div>
                </Col>
              </Row>
            </div>
            </>
        }
        <div className="concierge-list-close" onClick={() => onToggle()}>
          <IconContext.Provider value={{ color: '#242424', size: '18px' }}>
            <div>
              <GrClose />
            </div>
          </IconContext.Provider>
        </div>
      </Modal>
    )
  }
}


export default ModalConciergeList
